if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;
        if (this.elements.thumbnails) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
            thumb
              .querySelector('button')
              .addEventListener('click', () => this.setActiveMedia(thumb.dataset.target, false));
          });
        }

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const targetId = event.detail.currentElement?.dataset?.mediaId;
        const thumb = this.elements.thumbnails?.querySelector(`[data-target="${targetId}"]`);
        this.setActiveThumbnail(thumb);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        // Set active media
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        // Reorder if needed
        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }
          const activeThumb = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumb && activeThumb.parentElement.firstChild !== activeThumb) {
            activeThumb.parentElement.prepend(activeThumb);
          }
          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          const activeRect = activeMedia.getBoundingClientRect();
          if (activeRect.top <= -0.5) {
            window.scrollTo({ top: activeRect.top + window.scrollY, behavior: 'smooth' });
          }
        });

        this.playActiveMedia(activeMedia);

        // Update thumbnail
        if (this.elements.thumbnails) {
          const thumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(thumb);
          const position = thumb?.dataset?.mediaPosition;
          this.announceLiveRegion(activeMedia, position);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!thumbnail || !this.elements.thumbnails) return;
        this.elements.thumbnails.querySelectorAll('button').forEach(btn => btn.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', 'true');

        if (!this.elements.thumbnails.isSlideVisible?.(thumbnail, 10)) {
          this.elements.thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('img');
        if (!image || !this.elements.liveRegion) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        const deferred = activeItem.querySelector('.deferred-media');
        if (deferred) deferred.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader ||= document.querySelector('sticky-header');
        this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        const viewerSlider = this.elements.viewer.slider;
        if (!viewerSlider) return;
        viewerSlider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
